<div class="print-section" [ngClass]="isPrinting ? 'duringPrint' : 'beforeAndAfterPrint'">
    <div
        *transloco="let t; read: 'print'"
        class="printContainer"
        [ngClass]="isNested ? 'nested' : ''">
        @if (!isNested) {
            <div class="headerRow border-b padding-b">
                <img
                    style="width: 3rem; height: 3rem; margin-right: auto; margin-left: 0"
                    src="assets/images/logo/logo.png" />
                <h1 class="bpTitle"> {{ t('businessProcess') }} </h1>
            </div>
            <div class="headerRow">
                <h1 class="h1">
                    <b> {{ process()?.wbs }} </b>{{ ' - ' + process()?.titel }}
                </h1>
                <h3 class="h3 my-auto">
                    <b> {{ t('version') }}: {{ process()?.version }} </b></h3
                >
            </div>
        } @else {
            <div class="headerRow">
                <h3 class="h3">
                    <b> {{ process()?.wbs }} </b>{{ ' - ' + process()?.titel }}
                </h3>
                <h3 class="h3 my-auto">
                    <b> {{ t('version') }}: {{ process()?.version }} </b></h3
                >
            </div>
        }

        <h2 class="h2">
            <b> {{ t('details') }} </b>
        </h2>
        <table>
            <tr>
                <td class="headerCol">{{ t('version') }}:</td>
                <td> {{ process()?.version }} </td>
            </tr>
            <tr>
                <td class="headerCol">{{ t('description') }}:</td>
                <td> {{ process()?.description }} </td>
            </tr>
            <tr>
                <td class="headerCol">{{ t('owner') }}:</td>
                <td> {{ process()?.owner }} </td>
            </tr>
            <tr>
                <td class="headerCol"> {{ t('businessDomain') }}: </td>
                <td> {{ process()?.area }} </td>
            </tr>
            <tr>
                <td class="headerCol"> {{ t('status') }}: </td>
                <td> {{ process()?.status ?? 'N/A' }} </td>
            </tr>
        </table>

        <h2 class="h2">
            <b>{{ t('instructions') }}</b>
        </h2>
        <div class="commonDescription" [innerHTML]="process()?.text1"></div>
        <h2 class="h2">
            <b>{{ t('description') }}</b>
        </h2>
        <div class="commonDescription" [innerHTML]="process()?.text2"></div>

        <div class="page-break"></div>

        <h2 class="h2 border-t padding-t">
            <b>{{ t('flowchart') }}</b>
        </h2>
        <lib-svg-flowchart
            [processes]="tasks"
            [cameraScale]="cameraScale"
            [isPrinting]="true"
            type="flowchart2"></lib-svg-flowchart>

        <h2 class="h2">
            <b>{{ t('tasks') }}</b>
        </h2>
        <div class="tasks">
            <div class="border-b padding-b" *ngFor="let task of tasks(); trackBy: trackByFn">
                <div class="task">
                    <h4 class="h4">
                        <b>{{ task.data.action.no }}</b> - {{ task.data.action.title1 }}
                    </h4>
                    <data-view-mode
                        valueProp="id"
                        [service]="service"
                        [model]="task"
                        [showHeader]="false"></data-view-mode>
                    <div class="commonDescription">
                        <p
                            [innerHTML]="
                                taskDescription === 'instructions'
                                    ? task.data.text1
                                    : task.data.text2
                            "></p>
                    </div>
                    @if (task.data.action.category === 'M_PROCESS' && task.linkedProcessId) {
                        <lib-bp-recursive-print
                            [isNested]="true"
                            [processId]="task.linkedProcessId"
                            [service]="service"></lib-bp-recursive-print>
                    }
                </div>
            </div>
        </div>
    </div>
</div>
